import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

import { useSetPublicProfile } from './use-set-public-profile'
import { useSupplierMe } from './use-supplier-me'

export function PublicProfileCard({ onSuccess }: { onSuccess: () => void }) {
  const { data: supplier, isError } = useSupplierMe()
  const mutation = useSetPublicProfile()

  // show the pending value so the switch moves on tap instead of after the round trip
  const checked = mutation.isPending
    ? mutation.variables
    : (supplier?.publicProfileEnabled ?? false)

  return (
    <div className='flex w-full flex-col gap-4 rounded-2xl border border-border bg-page p-4 sm:p-6'>
      <h2 className='text-[16px] font-semibold text-ink'>Public profile</h2>
      <div className='flex items-start justify-between gap-4'>
        <div className='flex min-w-0 flex-col gap-1.5'>
          <Label
            htmlFor='publicProfileEnabled'
            className='text-[14px] leading-snug text-ink'
          >
            Show my company in the public Supplier Network
          </Label>
          <p id='publicProfileHelp' className='text-[13px] text-ink-soft'>
            Once verified, your profile is listed at
            platform.tandemone.net/supplier-network. Sales history, contacts,
            manufacturing locations, documents, capital equipment and policies
            stay visible to signed-in members only.
          </p>
        </div>
        <Switch
          id='publicProfileEnabled'
          aria-describedby='publicProfileHelp'
          className='mt-0.5'
          checked={checked}
          disabled={!supplier || mutation.isPending}
          onCheckedChange={enabled => mutation.mutate(enabled, { onSuccess })}
        />
      </div>
      {isError && (
        <p className='text-[12px] text-red-600'>
          Couldn't load this setting. Refresh the page to try again.
        </p>
      )}
    </div>
  )
}
